// extracted by mini-css-extract-plugin
export default {"root":"lET7RvC1kM1PHFqT01nQ","block":"bxOzD5t3ps81PnyuJt4R"};